import styled from "styled-components";
import { colorPalette, colors } from "_shared/styles/color"

export const FullContainer = styled.div<{ disabled: boolean, height?: number, color?: string }>`
    width: 100%;
    background-color: ${props => props.disabled ? colors.C13 : (props.color ||colorPalette.lighterSaphir)};
    height: ${props => props.height ?? '4'}px;
    border-radius: 16px;
`;


export const ProgressContainer = styled.div<{ width: number, disabled: boolean, height?: number, color?: string}>`
    height: ${props => props.height ?? '4'}px;
    background-color: ${props => props.disabled ? colorPalette.lunarRock : (props.color || colorPalette.saphir)};
    border-radius: 16px;
    width: ${props => props.width}% !important;
    transition: width 0.5s ease-in-out;
`;